import {Nullish} from 'utility-types';

import {useGetCustomTenantCatalogueQuery, useGetMakeModelWithMakeQuery} from '@dms/api/sales';
import {VehicleTypeEnumObject} from '@dms/api/shared';
import i18n, {FALLBACK_LANGUAGE} from '@dms/i18n';

import {Option, vehicleModelParser} from 'features/vehicle-catalogue';

interface UseVehicleModelProps {
  vehicleType: VehicleTypeEnumObject;
  make: string | Nullish;
  unknownModels?: Option[];
}

export function useVehicleModel(props: UseVehicleModelProps) {
  const vehicleModelQuery = useGetMakeModelWithMakeQuery(
    {
      vehicleType: props.vehicleType,
      make: props.make || '',
      lang: [i18n.resolvedLanguage ?? FALLBACK_LANGUAGE],
    },
    {skip: !props.vehicleType || !props.make}
  );

  const customTenantMakeModelsQuery = useGetCustomTenantCatalogueQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const isLoading = vehicleModelQuery.isLoading || customTenantMakeModelsQuery.isLoading;
  const isError = vehicleModelQuery.isError || customTenantMakeModelsQuery.isError;

  const parsedData = vehicleModelParser({
    vehicleType: props.vehicleType,
    customMakeLabel: props.make,
    fallbackMakeLabel: i18n.t('entity.vehicle.labels.otherLabel'),
    unknownModels: props.unknownModels || [],
    vehicleModelData: vehicleModelQuery.data,
    customTenantMakeModelData: customTenantMakeModelsQuery.data,
  });

  return {
    ...parsedData,
    isLoading,
    isError,
  };
}
